import { createContext } from 'react';
export var showedItemsContext = createContext(0);
